import React from 'react';
import { fromJS, List } from 'immutable';
import { Field, Fields } from 'redux-form/immutable';
import { useSelector } from 'react-redux';
import { BaseCurrencies } from '@joindeed/currency';

import FormDateWithStartAndEnd from 'retired/FormDateWithStartAndEnd';
import FormSelectBoxEntitySelector from 'retired/FormSelectBoxEntitySelector';
import FormAmountRangeSelector from 'retired/FormAmountRangeSelector';
import { MATCHING_REQUEST_STATUS_DISPLAY_KEYS } from 'containers/ExternalDonationRequests/types';
import { currencies } from 'utils/currencyFormat';
import { Features } from 'utils/features';
import { selectUser } from 'entities/user/selectors';

const currencyCodes = Object.keys(currencies);

export const ExternalDonationRequestsFilters = ({
  matchingRequestStatus,
}: {
  matchingRequestStatus: MATCHING_REQUEST_STATUS_DISPLAY_KEYS;
}): JSX.Element => {
  const capitalizedMatchingRequestStatusDisplayKey =
    MATCHING_REQUEST_STATUS_DISPLAY_KEYS[matchingRequestStatus]?.charAt(0)?.toUpperCase() +
    MATCHING_REQUEST_STATUS_DISPLAY_KEYS[matchingRequestStatus]?.slice(1);

  const user = useSelector(selectUser);

  return (
    <form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: 10,
      }}
    >
      <Fields
        names={['from', 'to']}
        component={FormDateWithStartAndEnd}
        placeholder={[
          `${capitalizedMatchingRequestStatusDisplayKey} from`,
          `${capitalizedMatchingRequestStatusDisplayKey} to`,
        ]}
        style={{ marginRight: 10, marginBottom: 10, width: 252 }}
      />
      <Fields
        names={['amountGte', 'amountLte']}
        component={FormAmountRangeSelector}
        placeholder={['Min amount', 'Max amount']}
        style={{ marginRight: 10, marginBottom: 10, width: 252 }}
        currencySymbol={currencies[user?.displayCurrency ?? BaseCurrencies.USD]?.symbol}
      />
      <Field
        name="currencies"
        component={FormSelectBoxEntitySelector}
        options={List(currencyCodes)}
        placeholder="Filter by currency"
        multiple
        style={{ marginRight: 10, marginBottom: 10, width: 160 }}
      />
      {user?.hasFeature(Features.AI_RECEIPT_READER) && (
        <Field
          name="confidenceScore"
          component={FormSelectBoxEntitySelector}
          options={fromJS([
            { id: '5', name: 'Certain' },
            { id: '4', name: 'High' },
            { id: '3', name: 'Moderate' },
            { id: '2', name: 'Low' },
            { id: '1', name: 'No confidence' },
          ])}
          placeholder="AI Review"
          multiple
          style={{ marginRight: 10, marginBottom: 10, width: 160 }}
        />
      )}
    </form>
  );
};

export default ExternalDonationRequestsFilters;
